// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import moment from 'moment';
import { Redirect } from 'react-router-dom';

// services
import { generateRandomNum } from 'services/data-utils';
import { TrumpismPropTypes } from 'services/dto/trumpism';

// data
import { requestTrumpisms } from 'actions/trumpisms';

// components
import Loader from 'components/Loader/Loader';

class Home extends PureComponent {
  state = {
    selectedTrumpismId: null
  };

  static propTypes = {
    requestTrumpisms: PropTypes.func.isRequired,
    trumpisms: ImmutablePropTypes.listOf(TrumpismPropTypes).isRequired
  };

  componentWillMount() {
    const { requestTrumpisms } = this.props;
    const today = moment().format('MM-DD');
    requestTrumpisms(today);
  }

  componentWillReceiveProps({ trumpisms }) {
    const { trumpisms: prevTrumpisms } = this.props;
    if (trumpisms.size && trumpisms !== prevTrumpisms) {
      const selectedTrumpismIndex = generateRandomNum(0, trumpisms.size - 1);
      this.setState({
        selectedTrumpismId: trumpisms.get(selectedTrumpismIndex).get('id')
      });
    }
  }

  render() {
    const { trumpisms } = this.props;
    const { selectedTrumpismId } = this.state;

    if (!trumpisms.size || !selectedTrumpismId) return <Loader />;

    return <Redirect to={`/${selectedTrumpismId}`} />;
  }
}

export default connect(
  state => ({
    trumpisms: state.getIn(['trumpisms', 'all'])
  }),
  { requestTrumpisms }
)(Home);



// WEBPACK FOOTER //
// ./src/views/Home.js